var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPath = function SvgPath(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "path_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#path_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 25.938a3.33 3.33 0 0 1-2.085-.704 3.27 3.27 0 0 1-1.206-1.797H13.75q-1.943 0-3.315-1.372-1.373-1.372-1.373-3.315t1.373-3.315q1.373-1.373 3.315-1.373h2.5q1.16 0 1.986-.826.826-.827.826-1.988t-.826-1.986a2.7 2.7 0 0 0-1.986-.825H9.54a3.4 3.4 0 0 1-1.214 1.797 3.3 3.3 0 0 1-2.076.704q-1.432 0-2.435-1.003-1.002-1.003-1.002-2.433 0-1.432 1.002-2.436Q4.818 4.063 6.25 4.063q1.17 0 2.076.703A3.4 3.4 0 0 1 9.54 6.563h6.709q1.942 0 3.315 1.372t1.372 3.315-1.372 3.315-3.315 1.373h-2.5q-1.161 0-1.986.826a2.7 2.7 0 0 0-.826 1.988q0 1.161.826 1.986a2.7 2.7 0 0 0 1.986.825h6.71a3.4 3.4 0 0 1 1.214-1.797 3.3 3.3 0 0 1 2.076-.703q1.433 0 2.435 1.002t1.003 2.433-1.003 2.436q-1.002 1.003-2.435 1.003M6.25 9.063q.651 0 1.107-.456T7.812 7.5t-.455-1.107a1.5 1.5 0 0 0-1.107-.455q-.651 0-1.107.455A1.5 1.5 0 0 0 4.688 7.5q0 .651.455 1.107.456.456 1.107.456"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPath);
export default ForwardRef;